// extracted by mini-css-extract-plugin
export default {"root":"_35xzy","icon":"_2nAdd","tooltip":"_3-0F4"};